import React, { useState } from "react";
import { FaTimes, FaInfoCircle, FaFlask } from "react-icons/fa";
import { Button, Modal } from "../ui";

// Beta messaging for the web portal: a one-time popup on first visit + a slim
// dismissible banner. The web app is still beta and many features are mobile-only.
const POPUP_KEY = "tarbaa_beta_popup_seen";
const BANNER_KEY = "tarbaa_beta_banner_hidden";

const read = (k) => {
  try {
    return localStorage.getItem(k);
  } catch {
    return null;
  }
};
const write = (k, v) => {
  try {
    localStorage.setItem(k, v);
  } catch {
    /* ignore (private mode / disabled storage) */
  }
};

const BetaNotice = () => {
  const [showPopup, setShowPopup] = useState(() => !read(POPUP_KEY));
  const [showBanner, setShowBanner] = useState(() => !read(BANNER_KEY));

  const dismissPopup = () => {
    write(POPUP_KEY, "1");
    setShowPopup(false);
  };
  const dismissBanner = () => {
    write(BANNER_KEY, "1");
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <div dir="rtl" className="border-b border-white/10 bg-white/[0.04] text-white/70">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 py-2 flex items-center gap-2.5 text-xs leading-snug">
            <FaInfoCircle className="shrink-0 text-primary" aria-hidden="true" />
            <span className="flex-1">
              نسخة تجريبية: بعض الميزات متوفرة في تطبيق الجوال فقط حالياً، وقد لا
              تُنقل إلى الويب.
            </span>
            <button
              type="button"
              onClick={dismissBanner}
              className="shrink-0 -m-1 p-1.5 rounded-md text-white/50 hover:text-white hover:bg-white/10"
              aria-label="إخفاء التنبيه"
            >
              <FaTimes size={12} aria-hidden="true" />
            </button>
          </div>
        </div>
      )}

      <Modal open={showPopup} onClose={dismissPopup} size="sm" labelledBy="beta-title">
        <div className="text-center -mt-4">
          <span className="mx-auto mb-4 w-14 h-14 rounded-2xl bg-primary/15 border border-primary/30 text-primary flex items-center justify-center">
            <FaFlask size={24} aria-hidden="true" />
          </span>
          <h2 id="beta-title" className="text-2xl font-extrabold">
            نسخة تجريبية
          </h2>
          <p className="text-white/70 leading-relaxed mt-2 mb-6">
            تطبيق الويب قيد التجربة. بعض الميزات لا تزال متوفرة في تطبيق الجوال
            فقط، وقد لا تُنقل إلى الويب.
          </p>
          <Button block onClick={dismissPopup}>
            فهمت
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default BetaNotice;
